var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balloon-halloween"},[_c('svg-sprite',{attrs:{"width":"40","height":"40","icon-id":"balloon-halloween","halloween":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }